module.exports = __webpack_public_path__ + "img/stock5.08986f61.png";